import { useMemo } from 'react';
import { DateTime } from 'luxon';
import { LabelType } from 'graphql/types';
import { useLabels } from 'modules/common/hooks';
import { useNoteInsightsContext } from '../NoteInsightsContextProvider';

export const useLabelVisibility = (): {
  CLIENT: boolean;
  PROJECT: boolean;
  TASK: boolean;
  SELECT: boolean;
} => {
  const { currentPeriod } = useNoteInsightsContext();
  const { endDate } = currentPeriod ?? {};
  const asOfDate = useMemo(() => {
    const now = DateTime.local();
    if (endDate) {
      const end = DateTime.fromISO(endDate);
      if (end >= now) {
        return now;
      }
      return end;
    }
    return now;
  }, [endDate]);

  const { timesheetLabels } = useLabels(asOfDate);
  const labelVisibility = {
    CLIENT: false,
    PROJECT: false,
    TASK: false,
    SELECT: false
  };
  timesheetLabels.forEach((item) => {
    if (item.type === LabelType.Client) labelVisibility.CLIENT = true;
    if (item.type === LabelType.Project) labelVisibility.PROJECT = true;
    if (item.type === LabelType.Task) labelVisibility.TASK = true;
    if (item.type === LabelType.Select) labelVisibility.SELECT = true;
  });
  return labelVisibility;
};
